import { render, staticRenderFns } from "./PaymentDetail.vue?vue&type=template&id=db43a1dc&scoped=true&"
import script from "./PaymentDetail.vue?vue&type=script&lang=js&"
export * from "./PaymentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db43a1dc",
  null
  
)

export default component.exports